import { render } from "./UnitSection.vue?vue&type=template&id=211a52b2&scoped=true"
import script from "./UnitSection.vue?vue&type=script&lang=js"
export * from "./UnitSection.vue?vue&type=script&lang=js"

import "./UnitSection.vue?vue&type=style&index=0&id=211a52b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211a52b2"]])

export default __exports__